export const getBlogPostsQuery = (tag: string, offset: number, limit: number) => {
    if (tag === 'all') {
        return `*[_type=="post"] {_id, title, excerpt,
                "slug": slug.current,
                    image,
                    tags[] -> {
                        _id,
                        title,
                        "slug": slug.current
                    },
                    _updatedAt,
                } | order(_updatedAt desc)[${offset}...${limit}]`;
    } else {
        return `*[_type=="post" && "${tag}" in tags[]->slug.current] {_id, title,
            "slug": slug.current,
            image,
            tags[] -> {
                _id,
                title,
                "slug": slug.current
            },
            _updatedAt,
        } | order(_updatedAt desc)[${offset}...${limit}]`;
    }
};
